import { HookInput } from 'components/UI/HookForm/Form/Input';

const Disclosure = () => {
  const today = new Date();

  return (
    <>
      <div className='p-6 space-y-4'>
        <h3 className='text-primaryColor-normal'>Disclosure</h3>
        <div className='space-y-4'>
          <section className='space-y-4'>
            <p className='font-bold'>
              By signing and submitting this application, the applicant hereby
              agrees to the following:
            </p>
            <ul className='list-disc space-y-4 px-4'>
              <li>
                Applicant agrees that the acceptance of this application does
                not commit the City to enter into an agreement, to payany costs
                incurred in its preparation to participate in subsequent
                negotiations, or to contract for the project. Further, the
                acceptance of this application does not constitute an agreement
                by the City that any contract will be entered into by the City.
                The city expressly reserves the right to reject any or all
                applications or to request more information from the applicant.
              </li>
              <li>
                The applicant also agrees that Façade Design Assistance will
                only be considered for the proposed project by the City if:1) a
                façade design has been completed and is included with this
                application, and 2) bids or quotes for all proposed work were
                obtained and are included with this application.
              </li>
              <li>
                Applicant hereby certifies that all information contained in
                this document and any attachments is true and correct to the
                best of the applicant’s knowledge. Applicant also gives
                permission to the City of Birmingham to research the building’s
                history, research the applicant’s history, contact respective
                financial institutions, obtain credit reports and perform other
                related activities necessary for the reasonable evaluation of
                this proposal.
              </li>
            </ul>
          </section>
          <section className='space-y-4'>
            <p className='font-bold'>
              Should assistance be provided applicant/borrower agrees:
            </p>
            <ul className='list-disc space-y-4 px-4'>
              <li>
                To comply with all applicable provisions of federal statutes and
                regulations concerning equal employment opportunities for
                persons engaged in rehabilitation work undertaken in connection
                with program assistance.
              </li>
              <li>
                To keep such records as may be required by the City in
                connection with the work to be assisted.
              </li>
              <li>
                To not discriminate upon the basis of race, color, sex, marital
                status, disability, religion or national origin in the sale,
                lease, rental, use or occupancy of the property to be assisted.
              </li>
              <li>
                To allow no member of the governing body of the City of
                Birmingham and no employee of the City of Birmingham to have any
                interest, direct or indirect, in the proceeds of any loan or in
                any way contract entered into by the borrower for the
                performance of work financed, in whole or in part, with the
                proceeds of the loan.
              </li>
              <li>
                That NO financial assistance will be provided if the project
                involves the permanent and involuntary displacement of tenants
                unless the applicant agrees to provide financial assistance to
                the tenants at levels consistent with the Federal Relocation and
                Real Property Acquisition Act, as amended. Such assistance
                granted will not, however, be counted in the private match
                requirement.
              </li>
            </ul>
          </section>
          <section className='space-y-4'>
            <p className='font-bold'>
              In addition, the applicant is aware of the following:
            </p>
            <ul className='list-disc space-y-4 px-4'>
              <li>
                The assistance involves federal funds and requires compliance
                with federal guidelines, including Davis-Bacon Wage Rates,
                Handicapped Accessibility and Historic Preservation.
              </li>
              <li>
                If assistance is given, an audit of the project may be required.
              </li>
              <li>
                The applicant will be obligated to maintain the building
                improvements for a period equal to the terms of the loan.
              </li>
              <li>
                Financial assistance will not be provided if property taxes or
                special assessments are in arrears.
              </li>
            </ul>
          </section>
        </div>
        <p className='font-bold py-4'>
          *Please note that incomplete applications will not be considered for
          funding.
        </p>
        <p className='font-bold'>
          Please Type your name below to serve as your signature and
          authorization to process this application.
        </p>
        <section className='py-4 w-1/3 space-y-4'>
          <HookInput
            customClassName='col-span-3'
            label='Print Name'
            id='print-name'
            name='step6.printName'
            type='text'
          />
          <HookInput
            customClassName='col-span-3'
            label='Title (if applicant is a company representative)'
            id='applicant-name'
            name='step6.applicantTitle'
            type='text'
          />

          <p>Date: {today.toLocaleDateString()}</p>
        </section>
      </div>
    </>
  );
};

export default Disclosure;
